import { Text } from '@/components/ui/text';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { Pressable } from 'react-native';

interface FriendshipBadgeProps {
  /**
   * Invoked on press. The caller owns the destructive confirm guard + the
   * remove-friend mutation; this pill just surfaces the tap affordance.
   */
  onManage: () => void;
  /** True while the remove-friend mutation is in flight. */
  isRemoving: boolean;
}

/**
 * A persistent, obviously-tappable "Friends" pill. Tapping it goes straight to
 * the caller's confirm guard — there is no hover swap and no dropdown menu, so
 * the trailing icon is a neutral status glyph (never a chevron/caret, which
 * would falsely imply a menu).
 */
export function FriendshipBadge({ onManage, isRemoving }: FriendshipBadgeProps) {
  return (
    <Pressable
      onPress={onManage}
      disabled={isRemoving}
      accessibilityRole="button"
      accessibilityLabel="Friends — tap to manage"
      className="flex-row items-center gap-1 rounded-sm border border-border bg-surface-secondary px-2 py-0.5 active:opacity-80"
      style={{ opacity: isRemoving ? 0.5 : 1 }}
    >
      <Text className="text-xs font-semibold text-muted-foreground">Friends</Text>
      <Ionicons name="people" size={12} className="text-muted-foreground" />
    </Pressable>
  );
}
